import AccessTimeIcon from '@mui/icons-material/AccessTime';

export const ActivityIcon = () => <AccessTimeIcon />;
